import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputCrmAnhangAttachementsRelation } from './InputCrmAnhangAttachementsRelation.entity';
import { InputTopicMarkRelation } from './InputTopicMarkRelation.entity';

export class InputAufgabeRelation<T extends EMode = EMode.entity> {
  /** Alias: attachements */
  attachements?: InputCrmAnhangAttachementsRelation<T>;
  /** Alias: topic */
  topic?: InputTopicMarkRelation<T>;

  __typename?: string;
}

const fields: FieldDefinitions<InputAufgabeRelation> = {
  attachements: {
    alias: 'attachements',
  },
  topic: {
    alias: 'topic',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputAufgabeRelationEntityDefinition: EntitiyDefinition<InputAufgabeRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputAufgabeRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
